var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"node-action-line"},[_c('div',{staticClass:"action-line--header node-list cat--negative"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"node-project-detail"},[_c('ProjectNativeFields',{attrs:{"model":_vm.model}}),_vm._v(" "),_vm._l((_vm.customFields),function(ref){
var id = ref.id;
var attributes = ref.attributes;
return [_c('ProjectCustomFields',{key:id,attrs:{"attributes":attributes}})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }